export const calculateTax = (tempRow) => {
    const { hst, qst, gst, pst } = tempRow;
    const preTotal = (parseFloat(hst ?? 0)) + (parseFloat(gst ?? 0)) + (parseFloat(pst ?? 0)) + (parseFloat(qst ?? 0));
    return preTotal;
};
